import gql from 'graphql-tag'

export const PRODUCT_X_SELL_FRAGMENT = gql`
  fragment xSellFragment on Product {
    xSell {
      title
      categoryId
      items {
        xSellScore
        xSellCategory
        title
        mainMenuUrlKey
        mainCategoryUrlKey
        ranking {
          avg
          cnt
        }
        isAdultOnly
        productTypeId
        mainVariant {
          discountPrice
          discountPromotionPrice
          hasSale
          inPromotion
          priceRrp
          price
          priceType
          defaultActualPrice
          variantId
          entityId
          mediaIdList
          variantUrl
          availability {
            isAvailable
            ourAvailability
          }
        }
      }
    }
  }
`
